import { create } from "zustand";
import { persist } from "zustand/middleware";
import { API_BASE_URL1, API_BASE_URL3 } from "../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../utils/apiCall";

export const useTripStore = create((set) => ({
  isInnerReportRequested: false,
  zoneWiseTrips: [],
  zoneWiseTripsWithTotals: [],
  circleWiseTrips: [],
  ownerTypes: [],
  isFetchingZoneWiseTrips: false,
  isFetchingCircleWiseTrips: false,
  isFetchingZoneWiseTripsError: false,
  isFetchingCircleWiseTripsError: false,
  //   for inner reports
  tripDetails: [],
  isFetchingTripDetails: false,
  isFetchingTripDetailsError: false,

  setIsInnerReportRequested: (val) => {
    set({ isInnerReportRequested: val });
  },

  fetchZoneWiseTrips: async (queryParams) => {
    set({ isFetchingZoneWiseTrips: true });
    const queryString = new URLSearchParams(queryParams).toString();
    console.log(queryParams)
    try {
      const zoneWiseTrips = await apiCall({
        url: `${API_BASE_URL1}SATReport/SATZoneWiseTripsReport?${queryString}${queryParams.CorporationId ? `&CorporationId=${queryParams.CorporationId}` : ''}`,
        method: "get",
        token: localStorage.getItem("token"),
      });
      const totals = zoneWiseTrips.reduce(
        (acc, item) => {
          acc.oneTrip += item.oneTrip;
          acc.twoTrips += item.twoTrips;
          acc.threeTrips += item.threeTrips;
          acc.above4Trips += item.above4Trips;
          acc.reportedatTSSCTP += item.reportedatTSSCTP;
          acc.totalTrips += item.totalTrips;
          acc.quantityinMTEst += item.quantityinMTEst;
          return acc;
        },
        {
          //   zoneId: "Total", // Label for the totals row
          zoneName: "Total",
          oneTrip: 0,
          twoTrips: 0,
          threeTrips: 0,
          above4Trips: 0,
          reportedatTSSCTP: 0,
          totalTrips: 0,
          quantityinMTEst: 0.0,
        }
      );

      // Add the totals row to the original data
      const zoneWiseTripsWithTotals = [...zoneWiseTrips, totals];
      set({ zoneWiseTrips: zoneWiseTripsWithTotals });
    } catch (error) {
      set({
        isFetchingZoneWiseTrips: false,
        isFetchingZoneWiseTripsError: error,
      });
    } finally {
      set({
        isFetchingZoneWiseTrips: false,
      });
    }
  },

  fetchCircleWiseTrips: async (queryParams) => {
    set({ isFetchingCircleWiseTrips: true });
    const queryString = new URLSearchParams(queryParams).toString();
    try {
      const circleWiseTrips = await apiCall({
        url: `${API_BASE_URL1}SATReport/SATCircleWiseTripsReport?${queryString}${queryParams.CorporationId ? `&CorporationId=${queryParams.CorporationId}` : ''}`,

        method: "get",
        token: localStorage.getItem("token"),
      });
      const totals = circleWiseTrips.reduce(
        (acc, item) => {
          acc.oneTrip += item.oneTrip;
          acc.twoTrips += item.twoTrips;
          acc.threeTrips += item.threeTrips;
          acc.above4Trips += item.above4Trips;
          acc.reportedatTSSCTP += item.reportedatTSSCTP;
          acc.totalTrips += item.totalTrips;
          acc.quantityinMTEst += item.quantityinMTEst;
          return acc;
        },
        {
          //   zoneId: "Total", // Label for the totals row
          zoneName: "",
          circleName: "Total",
          wardName: "Total",
          oneTrip: 0,
          twoTrips: 0,
          threeTrips: 0,
          above4Trips: 0,
          reportedatTSSCTP: 0,
          totalTrips: 0,
          quantityinMTEst: 0.0,
        }
      );
      const circleWiseTripsWithTotals = [...circleWiseTrips, totals];
      set({ circleWiseTrips: circleWiseTripsWithTotals });
    } catch (error) {
      set({
        isFetchingCircleWiseTripsError: error,
      });
    } finally {
      set({ isFetchingCircleWiseTrips: false });
    }
  },

  //   for fetching inner report data
  fetchTripDetails: async (queryParams) => {
    set({ isFetchingTripDetails: true });
    const queryString = new URLSearchParams(queryParams).toString();
    console.log(queryString)
    try {
      const tripDetails = await apiCall({
        url: `${API_BASE_URL1}SATReport/SATInnerTripdetails?${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({ tripDetails, isFetchingTripDetails: false });
    } catch (error) {
      set({
        isFetchingTripDetails: false,
        isFetchingTripDetailsError: error,
      });
    }
  },
  fetchTotalTripDetails: async (queryParams) => {
    set({ isFetchingTripDetails: true });
    const queryString = new URLSearchParams(queryParams).toString();
    try {
      const tripDetails = await apiCall({
        url: `${API_BASE_URL1}SATReport/GetTotalTripsDetails?CollectionTypeId=2&${queryString}`,
        method: "get",
        token: localStorage.getItem("token"),
      });

      set({ tripDetails, isFetchingTripDetails: false });
    } catch (error) {
      set({
        isFetchingTripDetails: false,
        isFetchingTripDetailsError: error,
      });
    }
  },
}));
